<section>
  <app-style-guide-nav></app-style-guide-nav>

  <!-- Typography https://material.angular.io/guide/typography -->

  <!-- Large, one-off header, usually at the top of the page -->
  <h1 class="mat-display-4">Hero header</h1>

  <h1 class="mat-display-3">Hero header</h1>

  <h1 class="mat-display-2">Hero header</h1>

  <h1 class="mat-display-1">Hero header</h1>

  <!-- .mat-h1 or .mat-headline -->
  <h1 class="mat-h1">Section heading corresponding to the h1 tag.</h1>

  <!-- .mat-h2 or .mat-title -->
  <h2 class="mat-h2">Section heading corresponding to the h2 tag.</h2>

  <!-- .mat-h3 or .mat-subheading-2 -->
  <h3 class="mat-h3">Section heading corresponding to the h3 tag.</h3>

  <!-- .mat-h4 or .mat-subheading-1 or .mat-h5 or .mat-h6 -->
  <h4 class="mat-h4">Section heading corresponding to the h4 tag.</h4>

  <!-- .mat-body or .mat-body-1 -->
  <p class="mat-body">Base body text.</p>

  <!-- .mat-body-strong or .mat-body-2 -->
  <p class="mat-body-strong">Bolder body text.</p>

  <!-- .mat-small or .mat-caption -->
  <p class="mat-small">Smaller body and hint text.</p>

  <ol>
    <li>Ordered list item</li>
    <li>Ordered list item</li>
    <li>Ordered list item</li>
  </ol>

  <ul>
    <li>Unordered list item</li>
    <li>Unordered list item</li>
    <li>Unordered list item</li>
  </ul>
</section>
